import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { push } from "../../utils/navigation";
import { Button } from "reactstrap";
import {
    BASE_URL,
    GetIsBulkCustomerType,
    GetIsCollectionCustomer,
    GetIsFreshOilCustomer,
    IsNullOrUndefined
} from "../../constants";

const ClientHomeActionButtons = ({locationId, assignedCustomerTypes}) => {
  const dispatch = useDispatch();
  const clientLocationsDelivery = useSelector(
    (state) => state.home.clientLocationsDelivery || []
  );

  const hasDelivery = useMemo(() => {
    return clientLocationsDelivery && clientLocationsDelivery.length > 0;
  }, [clientLocationsDelivery]);

  const urlAdditional = useMemo(() => { 
      return locationId > 0 ? `/${locationId}` : "";
  }, locationId);
  
  const isBulk = useMemo(() => { 
      return IsNullOrUndefined(assignedCustomerTypes) || GetIsBulkCustomerType(assignedCustomerTypes);
  }, [assignedCustomerTypes]);

    const isCollectionCustomer = useMemo(() => {
        return IsNullOrUndefined(assignedCustomerTypes) || GetIsCollectionCustomer(assignedCustomerTypes);
    }, [assignedCustomerTypes]);

    const isFreshOilCustomer = useMemo(() => {
        return IsNullOrUndefined(assignedCustomerTypes) || GetIsFreshOilCustomer(assignedCustomerTypes);
    }, [assignedCustomerTypes]);
  
  return (
    <div className="flex justify-content-between mb-1 flex-wrap">
      <Button        
          className="bg-danger mb-1 py-1 mobile-full-width"
        style={{ width: "30%" }}
          disabled={!isCollectionCustomer}
        onClick={() => dispatch(push(`${BASE_URL}/request-urgent-collection${urlAdditional}`))}
      >
        Request Urgent Collection
      </Button>
      <Button
        className="bg-light-warning mb-1 py-1 mobile-full-width"
        disabled={!isFreshOilCustomer}
        style={{ width: "30%" }}
        onClick={() =>
          hasDelivery
            ? dispatch(push(`${BASE_URL}/request-oil-delivery${urlAdditional}`))
            : dispatch(push(`${BASE_URL}/request-new-oil${urlAdditional}`))
        }
      >
        {hasDelivery ? "Request New Oil Delivery" : "New Oil"}
      </Button>
      <Button          
        className="bg-primary mb-1 py-1 mobile-full-width"
        style={{ width: "30%" }}
          disabled={!isBulk}
        onClick={() => dispatch(push(`${BASE_URL}/request-tank-swap${urlAdditional}`))}
      >
        Tank Repair
      </Button>
    </div>
  );
};

export default ClientHomeActionButtons;
